<template>
  <div class="com-wiki-card" @click="openWiki">
    <OutOpen
      :protocol="heyboxProtocol"
      :page-identifier="'bbs/link'"
      v-if="canUseDeepLink && articleInfo.source == 'share'"
    ></OutOpen>
    <template v-if="!is_loading">
      <div
        class="header-section"
        :style="{ 'background-image': `url(${card_data.head_image})` }"
      >
        <p class="static-color-wiki-name">{{ card_data.name }}</p>
      </div>
      <div class="info-section">
        <div class="wiki-icon-box">
          <img v-hb-img.src="card_data.icon" alt="" class="wiki-icon" />
        </div>
        <div class="info-line">
          <span class="words-num">{{ card_data.article_num }}</span>
          <span class="words-num-desc">个词条</span>
          <span class="enter-wiki">进入百科</span>
          <hb-icon name="common-arrow-right-line"></hb-icon>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin';
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import OutOpen from '_com/OutOpen';
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  data() {
    return {
      is_loading: true,
      card_data: {},
    };
  },
  created() {
    this.getData();
  },
  components: {
    OutOpen,
  },
  methods: {
    async getData() {
      const {
        data: { result, status },
      } = await this.dataInfo.request;
      if (status != 'ok') {
        return;
      }
      this.card_data = result.wiki_infos.find(
        (item) => item.wiki_id == this.dataInfo.id,
      );
      if (!this.card_data) return;
      this.is_loading = false;
      // console.log('[wiki]:', this.card_data);
    },
    openWiki() {
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(this.heyboxProtocol);
          break;
        }
        case 'post': {
          if (this.card_data.app_id) {
            executeProtocol({
              protocol_type: 'openGameDetail',
              app_id: this.card_data.appid,
              game_type: this.card_data.game_type,
              page: 'wiki',
              h_src: this.card_data.h_src,
            });
          } else {
            executeProtocol({
              protocol_type: 'openGameDetail',
              app_id: this.card_data.wiki_id,
              game_type: this.card_data.game_type,
              page: 'wiki',
              // h_src: _this.data.h_src
            });
          }
          break;
        }
      }
    },
  },
  computed: {
    heyboxProtocol() {
      return (
        'heybox://' +
        encodeURIComponent(
          JSON.stringify({
            protocol_type: 'openGameDetail',
            app_id: this.card_data.wiki_id,
            game_type: this.card_data.game_type,
            page: 'wiki',
            h_src: 'share',
          }),
        )
      );
    },
  },
};
</script>

<style lang="less">
.com-wiki-card {
  position: relative;
  height: 80px;
  margin-top: 12px;
  padding: 4px 4px 8px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .header-section {
    height: 46px;
    width: 100%;
    border-radius: 2px;
    padding: 7px 6px;
    background-size: 100% auto;
    background-position: center center;
    .static-color-wiki-name {
      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
    }
  }
  .info-section {
    position: relative;
    display: flex;
    align-items: center;
    height: 22px;
    padding: 6px 0 0 50px;
    .wiki-icon-box {
      position: absolute;
      bottom: 0;
      left: 6px;
      width: 36px;
      height: 36px;
      .wiki-icon {
        width: inherit;
        height: inherit;
        border-radius: 4px;
      }
    }
    .info-line {
      display: flex;
      align-items: center;
      width: 100%;
      .words-num {
        font-family: Helvetica;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        color: rgba(20, 25, 30, 1);
      }
      .words-num-desc {
        margin-left: 2px;
        font-size: 10px;
        line-height: 16px;
        color: rgba(140, 145, 150, 1);
      }
      .enter-wiki {
        margin-left: auto;
        font-size: 10px;
        line-height: 16px;
        color: rgba(140, 145, 150, 1);
      }
      i {
        margin-left: 2px;
        font-size: 10px;
        line-height: 16px;
        color: rgba(140, 145, 150, 1);
      }
    }
  }
}
</style>
